import { eachDayOfInterval, eachMonthOfInterval, eachWeekOfInterval } from "date-fns";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import { doesWeekStartFromMonday } from "@app/util/dates";

import { Granularity } from "../common";

// The distances table holds one row per user per local day, so it cannot resolve anything
// finer than a day. Callers map an "hour" granularity to "day" before getting here.
export type DailyGranularity = Exclude<Granularity, "hour">;

const generators: Record<DailyGranularity, (range: DateRange) => Date[]> = {
  day: (range) => eachDayOfInterval({ end: range.endDate, start: range.startDate }),
  month: (range) => eachMonthOfInterval({ end: range.endDate, start: range.startDate }),
  week: (range) =>
    eachWeekOfInterval(
      { end: range.endDate, start: range.startDate },
      { weekStartsOn: doesWeekStartFromMonday() ? 1 : 0 }
    ),
};

export const getDistanceBuckets = (range: DateRange, granularity: DailyGranularity): Date[] =>
  generators[granularity](range);

export default getDistanceBuckets;
